import { ARTICLE_TYPES } from "~constants";
import { Story } from "~types/types";

const getArticleType = (story: Story) =>
    ARTICLE_TYPES[story?.type || ""] ?? ARTICLE_TYPES.default;

export default getArticleType;
